import { ApiProperty } from "@nestjs/swagger";

export class ProductIdRequest{
    @ApiProperty()
    productId: number;
    @ApiProperty()
    plantId: number;
}